import type { CSSProperties } from 'react';
import type { ToasterProps } from 'sonner';
import { CircleCheckIcon, InfoIcon, Loader2Icon, OctagonXIcon, TriangleAlertIcon } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';

type ToasterTheme = NonNullable<ToasterProps['theme']>;

function isToasterTheme(theme: string): theme is ToasterTheme {
  return theme === 'light' || theme === 'dark' || theme === 'system';
}

const TOASTER_STYLE: CSSProperties & Record<`--${string}`, string> = {
  '--normal-bg': 'var(--background)',
  '--normal-text': 'var(--text-dark)',
  '--normal-border': 'var(--border)',
};

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();

  return (
    <Sonner
      theme={isToasterTheme(theme) ? theme : 'system'}
      className="toaster group"
      icons={{
        success: <CircleCheckIcon className="size-4" />,
        info: <InfoIcon className="size-4" />,
        warning: <TriangleAlertIcon className="size-4" />,
        error: <OctagonXIcon className="size-4" />,
        loading: <Loader2Icon className="size-4 animate-spin" />,
      }}
      style={TOASTER_STYLE}
      {...props}
    />
  );
};

export { Toaster };
